var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemberHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconMemberHollow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Border"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 48,
    height: 48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberHollow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27,35H21V13h6Zm2,2V11H19V37H29Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberHollow);
export default __webpack_public_path__ + "static/media/IconMemberHollow.9d1719004d94e1bed5a36997c7498c77.svg";
export { ForwardRef as ReactComponent };